import { SchoolUser, SchoolUserType } from '@core/models/domain/account.domain';

/**
 * The two roles the backend treats as school-wide admins
 * (ChildAccessAuthorizationService.SCHOOL_WIDE_ROLES). Keep this list in step with it: the
 * backend is the enforcement point, this is what the UI uses to avoid offering a staff member
 * pages whose every action the server will refuse.
 */
export const SCHOOL_ADMIN_ROLES: readonly SchoolUserType[] = [
  SchoolUserType.HEAD_TEACHER,
  SchoolUserType.ADMINISTRATOR
];

export function isSchoolAdmin(user: SchoolUser | null | undefined): boolean {
  return !!user?.schoolUserType && SCHOOL_ADMIN_ROLES.includes(user.schoolUserType);
}
